<template>
  <div class="social-networks">
    <el-popover placement="left" trigger="click" width="390">
      <el-button slot="reference" icon="el-icon-share" circle></el-button>
      <div class="social-networks__list">
        <div v-for="(value, key) in channels" :key="new Date().getTime() + key"
             class="social-networks__list--item">
              <span class="social-networks__list--item-title" @click="openSocial(key, value)">
                <img :class="key" :src="socialImage(key)" :alt="key">
                {{ socialNetworks[key] }}
              </span>
          <div class="social-networks__list--item-options">
            <div v-if="value">
              <el-radio-group :value="value.approved" size="small">
                <div class="mr5" @click.once="updateSocialNetwork(key, 1, value)">
                  <el-radio-button :label="1">Approve</el-radio-button>
                </div>
                <div class="mr5" @click.once="updateSocialNetwork(key, 2, value)">
                  <el-radio-button :label="2">Reject</el-radio-button>
                </div>
                <div @click.once="updateSocialNetwork(key, 3, value)">
                  <el-radio-button :label="3">OTW</el-radio-button>
                </div>
              </el-radio-group>
            </div>
            <i v-else class="el-icon-error fa-lg"></i>
          </div>
        </div>
      </div>
    </el-popover>

    <el-dialog title="Select Tier" :visible.sync="dialogTier" width="30%" top="3vh">
      <el-select v-model="user_tier" clearable filterable class="mr10 capitalize">
        <el-option v-for="t in user_tiers" :key="t.value" :value="t.value" :label="t.name"></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="updateUserTier">
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      socialNetworks: { instagram: 'Instagram', tiktok: 'TikTok', youtube: 'YouTube' },
      user_tiers: [
        { value: null, name: '/' },{ value: 1, name: 'Bronze' }, { value: 2, name: 'Silver' }, { value: 3, name: 'Gold' }
      ],
      dialogTier: false,
      user_tier: '',
    }
  },

  props: {
    channels: { type: Object, default: () => ({}) }
  },

  watch: {
    dialogTier(newVal) {
      this.$emit('tierModal', newVal)
    }
  },

  methods: {
    ...mapActions('user', ['updateSocialNetworkStatus', 'read']),
    ...mapActions('creatorUsers', ['readCreatorUsers']),
    ...mapActions('mcnUsers', ['readMcnUsers']),

    openSocial(platform, data) {
      if (data) {
        if (platform === 'youtube') window.open('https://youtube.com/channel/' + data.channelId)
        else window.open(data.channelId)
      }
    },

    socialImage(social) {
      return require(`@/assets/icons/${social}.svg`)
    },

    updateSocialNetwork(platform, value, socialData) {
      const data = { status: value, channelId: socialData.id }
      this.currentSocial = { ...socialData, platform }

      if (value === 1 && platform === 'youtube') this.dialogTier = true
      if (value === 2 || value === 3 || (value === 1 && platform !== 'youtube')) {
        this.$confirm(
            `Do you really want to ${value === 1 ? 'approve' : value === 2 ? 'reject' : 'send otw email for'} ${this.socialNetworks[platform]} account`,
            { confirmButtonText: 'Yes', cancelButtonText: 'No', type: 'warning' }
        ).then(() => {
          this.updateSocialNetworkStatus(data).then(() => {
            this.readData()
          })
        })
          .catch(() => {
            this.$forceUpdate()
          })
      }
    },

    updateUserTier() {
      this.updateSocialNetworkStatus({
        status: 1, channelId: this.currentSocial.id, tier: this.user_tier
      }).then(() => {
        this.dialogTier = false
        this.readData()
      })
        .catch(() => {
          this.$forceUpdate()
        })
    },

    readData() {
      this.read()
      this.readCreatorUsers()
      this.readMcnUsers()
    },
  }
}
</script>

<style scoped lang="scss">

.social-networks {
  display: inline-block;
  margin-left: 10px;
}

</style>
